'use client';

import { ChangeEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { PostResponse } from '@/queries/posts/usePost';
import { useUpdatePost } from '@/queries/posts/useUpdatePost';

export const PostTitle = ({ post, label }: { post: PostResponse; label?: string }) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState(post.post.title ?? '');
  const { mutate: updatePost } = useUpdatePost();

  const debouncedUpdatePost = useDebouncedCallback(
    (value: string) => {
      updatePost({ id: post.post.id, title: value });
    },
    {
      delay: 300,
      flushOnUnmount: true,
    }
  );

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setTitle(e.target.value);
      debouncedUpdatePost(e.target.value);
    },
    [debouncedUpdatePost]
  );

  return (
    <TextInput
      flex={1}
      placeholder={t('post.title-placeholder')}
      label={label}
      value={title}
      onChange={handleChange}
    />
  );
};
